export default __webpack_public_path__ + "static/media/be-there-grey.ee155a06.svg";